import { call, take, put, fork, all } from 'redux-saga/effects';
// import { ChatActionTypes } from '../chatmedicalmanage/type';
import { StaticToast } from 'src/components/common';
import { cookies, fetchJson, groupBy, validate } from 'src/utils';
import { processLoginData } from 'src/utils/serialization';
import { ConfigActionTypes } from './type';
// import * as Sentry from "@sentry/browser";
// import storage from 'src/utils/storage';

function* fetch_channel_config() {
  while (true) {
    const action = yield take(ConfigActionTypes.FETCH_CHANNEL_CONFIG);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/user/bindThirdUser',
        type: 'POST',
        data: {
          ...options,
        },
        isloading: false,
        needLogin: false,
        action,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        processLoginData(result);
        yield put({
          type: ConfigActionTypes.FETCH_CHANNEL_CONFIG_SUCCESS,
          channelSource: options.channelSource,
        });
        typeof onSuccess === 'function' && onSuccess(res);

      } else if(res.code === '100020') {
        window.reactHistory.replace({
          pathname:'/hospital/login',
          search:`pathname=${encodeURIComponent(location.pathname)}&jumpSearch=${encodeURIComponent(location.search.slice(1))}`,
        });
      }else if (res.code === '100016') {
        window.reactHistory.replace({
          pathname: '/hospital/close',
        });
      } else if(res.code !== '20002') {
        window.reactHistory.replace({
          pathname: '/hospital/error',
        });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* fetch_banner() {
  while (true) {
    const action = yield take(ConfigActionTypes.FETCH_BANNER);
    try {
      const { options, onSuccess } = action;
      const za_token = cookies.get('za_token') || '';
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/ad/list/rightGlobalPopup',
        type: 'POST',
        data: {
          ...options,
          channelResourceCode: cookies.get('channelResourceCode') || '',
        },
        isloading: false,
        needLogin: false,
        action,
      });
      const { code = '0', result = [] } = res;

      if (code === '0' && result.length) {
        const isAlipayEnv = validate.isAlipayApplet();
        const filteredResult = (result || []).filter((item: any) => {
          if (item.alipayShow === 'N' && isAlipayEnv) {
            return false;
          }
          return true;
        });
        console.log(filteredResult);
        const {adPositionList = []} = options;
        const BANNER = 'banner';
        const HOME_POPUP = 'home_popup';
        const FOOTER_BANNER = 'rights_page_bottom_message';
        const SERVPACK_PAY_SUCCESS_BANNER = 'servpack_pay_success_page';
        // 个人中心底部 banner
        const PERSON_CENTER_BANNER = 'personal_center';
        const INQUIRY_CHAT_BOTTOM_BANNER = 'inquiry_chat_bottom_banner';
        let reducerData = {};
        const adsCategory = groupBy(filteredResult, ({ adPosition }) => adPosition);
        const AD_POSITIONS = [HOME_POPUP, BANNER, FOOTER_BANNER, SERVPACK_PAY_SUCCESS_BANNER, PERSON_CENTER_BANNER, INQUIRY_CHAT_BOTTOM_BANNER];
        if(adPositionList.some((position) => AD_POSITIONS.includes(position))){ // 首页弹窗、banner
          const adList = (adsCategory[BANNER] || []).slice(0, 5) as any[];
          const homePopups = (adsCategory[HOME_POPUP] || []) as any[];
          const footerBannerList = (adsCategory[FOOTER_BANNER] || []) as any[];
          const servpackBannerList = (adsCategory[SERVPACK_PAY_SUCCESS_BANNER] || []) as any[];
          const personCenterBannerList = (adsCategory[PERSON_CENTER_BANNER] || []) as any[];
          const inquiryChatBottomBanner = (adsCategory[INQUIRY_CHAT_BOTTOM_BANNER] || []) as any[];
          const list: any[] = [];
          adList.forEach((element) => {
            const {
              adType = '',
              adRequestUrl = '',
              adName = '',
              adPosition = '',
              attachmentDomain: { attachmentDownloadUrl = '' } = {},
              adNo = '',
              popUpAttachmentDomain,
            } = element;
            list.push({
              adUrl: attachmentDownloadUrl,
              adType,
              adRequestUrl,
              adName,
              adPosition,
              adNo,
              popUpAttachmentDomain,
            });
          });

          const popups = homePopups
            .map((popup) => {
              let url;
              let adRule;

              try {
                const { attachmentDomain: { attachmentDownloadUrl = '' } = {} } = popup;
                url = attachmentDownloadUrl;
                adRule = JSON.parse(popup.adRule);
              } catch (e) {
                console.log(e);
                return false;
              }

              return {
                url,
                type: popup.adType,
                link: popup.adRequestUrl,
                appId: popup.targetAppId,
                extraData: popup.extraData,
                adName: popup.adName || '',
                adRule,
                adPosition: popup.adPosition,
                adNo: popup.adNo,
                popUpAttachmentDomain: popup.popUpAttachmentDomain,
                xproTemplateCode: popup.xproTemplateCode,
                shuntCode: popup.shuntCode,
              };
            })
            .filter((i) => {
              if (typeof i === 'object') {
                return i.type == 1 || i.type == 2;
              }
              return i;
            });
          reducerData = {
            bannerList: list,
            homePopups: popups,
            footerBannerList,
            personCenterBannerList,
            inquiryChatBottomBanner,
            servpackBannerList,
            isHomePopupsWithLogin: za_token ? true : false,
          };

        }else{
          reducerData = adsCategory;
        }
        yield put({
          type: ConfigActionTypes.FETCH_BANNER_SUCCESS,
          data:reducerData,
        });

        typeof onSuccess === 'function' && onSuccess(res);

      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error('网络异常，请稍后重试');
    }
  }
}

// 获取用户账户信息
function* fetch_userAccountInfo() {
  while (true) {
    const action = yield take(ConfigActionTypes.FETCH_USERINFO);
    try {
      const { onSuccess,options={} } = action;
      const res = yield call(fetchJson, {
        type: 'GET',
        url: '/api/api/v1/patient/user/getAccountInfo',
        data:options,
        isloading: true,
      });
      const { code = '0', result = {} } = res;
      if (code === '0') {
        typeof onSuccess === 'function' && onSuccess(res);
        yield put({ type: ConfigActionTypes.FETCH_USERINFO_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

// 获取可以展示加企微的资源位
function* fetch_addWorkWechatResourceList() {
  while (true) {
    const action = yield take(ConfigActionTypes.FETCH_ADDWECHATRESOURCES);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        type: 'POST',
        data: {
          // "applicationIdList":[1,3],
          firstBusinessIdList:[12],
        },
        url: '/api/api/v1/patient/channel/getAddWorkWechatResourceList',
        isloading: false,
        needLogin: false,
      });
      const { code = '0', result = [] } = res;
      if (code === '0') {
        typeof onSuccess === 'function' && onSuccess(res);
        const channelResourceCode = cookies.get('channelResourceCode');
        const showAddWechat = result.includes(channelResourceCode);
        yield put({ type: ConfigActionTypes.FETCH_ADDWECHATRESOURCES_SUCCESS, data: {
          showAddWechat,
        } });
      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error('网络异常，请稍后重试');
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_channel_config),
    fork(fetch_banner),
    fork(fetch_userAccountInfo),
    fork(fetch_addWorkWechatResourceList),
  ]);
}
